/**
 * Typ menu v toolbaru
 */
export enum MenuType {
    mtForm,
    mtPrint,
    mtActions,
    mtConditionForm,
    mtWorkflow,
    mtHelp,
    mtNone,
    mtRecord,
    mtFormControl,
    mtCancelSave,
    mtStandardAction,
    mtRecordNavigation,
    mtFilter,
    mtInfo,
    mtSettings,
    mtFrameMenu,
}
